import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAInitialState, IAStateTypes } from './ia.state';
import { fetchIADataSet, saveIAData } from 'store/feature/ia/ia.thunk.ts';
import { QueryState } from '@/common/enum';
import { IAData } from 'interfaces/ia.interface.ts';
import {
  LegendStatus,
  MarkerTypeWithoutIcon,
} from 'pages/MapPage/components/ModalLegends/Constants.tsx';

const initialState: IAStateTypes = IAInitialState;

export const iaSlice = createSlice({
  name: 'ia',
  initialState,
  reducers: {
    setCurrentIAEntry: (state, action: PayloadAction<IAData | null>) => {
      state.currentEntry = action.payload;
    },
    updateIADataSet: (state, action: PayloadAction<IAData[]>) => {
      if (!state.iaDataset) return;
      state.iaDataset.dataset = action.payload;
    },
    updateMapLegendStatus: (state, action: PayloadAction<MarkerTypeWithoutIcon[]>) => {
      state.mapLegendStatus = action.payload;
    },
    setAllCheckedStatus: (state, action: PayloadAction<boolean>) => {
      state.allCheckedStatus = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchIADataSet.pending, (state) => {
        state.queryState = QueryState.AWAIT;
        state.error = null;
        state.iaDataset = null;
      })
      .addCase(fetchIADataSet.fulfilled, (state, action) => {
        state.queryState = QueryState.READY;
        state.iaDataset = action.payload ?? null;
        if (action.payload && action.payload.dataset) {
          state.allCheckedStatus = true;
          state.mapLegendStatus = LegendStatus.map(({ icon, ...rest }) => rest);
          state.originalDataset = action.payload.dataset;
        }
      })
      .addCase(fetchIADataSet.rejected, (state, action) => {
        state.queryState = QueryState.FAIL;
        state.error = action.error.message ?? null;
      })
      .addCase(saveIAData.pending, (state) => {
        state.queryState = QueryState.AWAIT;
        state.error = null;
      })
      .addCase(saveIAData.fulfilled, (state) => {
        state.queryState = QueryState.READY;
        state.currentEntry = null;
      })
      .addCase(saveIAData.rejected, (state, action) => {
        state.queryState = QueryState.FAIL;
        state.error = action.error.message ?? null;
      });
  },
});

export default iaSlice.reducer;
